const routeConfi = [
    {
        path: "/dashboard/",
        elementKey: "Dashboard",
        meta: {
            title: "داشبورد",
            breadcrumb: ["داشبورد"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "dashboard",
                icon: "feather-home",
                label: "داشبورد اصلی",
                showAlways: true
            },
        },
    },
    {
        path: "/profile/users/",
        elementKey: "ProfileUsers",
        meta: {
            title: "اشخاص",
            breadcrumb: ["اطلاعات عمومی", "اشخاص"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-users",
                label: "اشخاص",
            },
        },
    },
    {
        path: "/profile/branches/",
        elementKey: "ProfileBranches",
        meta: {
            title: "شعب اشخاص",
            breadcrumb: ["اطلاعات عمومی", "شعب اشخاص"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-git-branch",
                label: "شعب اشخاص",
            },
        },
    },
    {
        path: "/profile/features/",
        elementKey: "ProfileFeatures",
        meta: {
            title: "ویژگی‌ها",
            breadcrumb: ["اطلاعات عمومی", "ویژگی‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-feather",
                label: "ویژگی‌ها",
            },
        },
    },
    {
        path: "/profile/price/centers/",
        elementKey: "CostCenters",
        meta: {
            title: "مراکز هزینه",
            breadcrumb: ["اطلاعات عمومی", "مراکز هزینه"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-dollar-sign",
                label: "مراکز هزینه",
            },
        },
    },
    {
        path: "/profile/bank/accounts/",
        elementKey: "BankAccounts",
        meta: {
            title: "حساب‌های بانکی",
            breadcrumb: ["اطلاعات عمومی", "حساب‌های بانکی"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-credit-card",
                label: "حساب‌های بانکی",
            },
        },
    },
    {
        path: "/products/management/",
        elementKey: "UserProducts",
        meta: {
            title: "کالاها و خدمات",
            breadcrumb: ["اطلاعات عمومی", "کالاها و خدمات"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-package",
                label: "کالاها و خدمات",
            },
        },
    },
    {
        path: "/accounting/persons/",
        elementKey: "AccountingPersons",
        meta: {
            title: "نام افراد حسابداری",
            breadcrumb: ["اطلاعات عمومی", "نام افراد حسابداری"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "general_info",
                icon: "feather-user-check",
                label: "نام افراد حسابداری",
                condition: "module_accounting_persons"
            },
        },
    },
    {
        path: "/base/accounts/group/",
        elementKey: "AccountGroups",
        meta: {
            title: "گروه حساب‌ها",
            breadcrumb: ["اطلاعات پایه", "گروه حساب‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-layers",
                label: "گروه حساب‌ها",
            },
        },
    },
    {
        path: "/base/accounts/koll/",
        elementKey: "KollAccounts",
        meta: {
            title: "حساب‌های کل",
            breadcrumb: ["اطلاعات پایه", "حساب‌های کل"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-book",
                label: "حساب‌های کل",
            },
        },
    },
    {
        path: "/base/accounts/moein/",
        elementKey: "MoeinAccounts",
        meta: {
            title: "حساب‌های معین",
            breadcrumb: ["اطلاعات پایه", "حساب‌های معین"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-book-open",
                label: "حساب‌های معین",
            },
        },
    },
    {
        path: "/base/accounts/tafsili/",
        elementKey: "TafsiliAccounts",
        meta: {
            title: "حساب‌های تفصیلی",
            breadcrumb: ["اطلاعات پایه", "حساب‌های تفصیلی"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-file-text",
                label: "حساب‌های تفصیلی",
            },
        },
    },
    {
        path: "/base/agreements/",
        elementKey: "Agreements",
        meta: {
            title: "قراردادها",
            breadcrumb: ["اطلاعات پایه", "قراردادها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-file",
                label: "قراردادها",
            },
        },
    },
    {
        path: "/base/activities/",
        elementKey: "Activities",
        meta: {
            title: "فعالیت‌ها",
            breadcrumb: ["اطلاعات پایه", "فعالیت‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-activity",
                label: "فعالیت‌ها",
            },
        },
    },
    {
        path: "/base/classify/confirmation/",
        elementKey: "ConfirmationClass",
        meta: {
            title: "رده تایید",
            breadcrumb: ["اطلاعات پایه", "رده تایید"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-check-circle",
                label: "رده تایید",
            },
        },
    },
    {
        path: "/base/positions/",
        elementKey: "Positions",
        meta: {
            title: "سمت‌ها",
            breadcrumb: ["اطلاعات پایه", "سمت‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-award",
                label: "سمت‌ها",
            },
        },
    },
    {
        path: "/base/forms/",
        elementKey: "Forms",
        meta: {
            title: "فرم‌ها",
            breadcrumb: ["اطلاعات پایه", "فرم‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "basic_info",
                icon: "feather-edit",
                label: "فرم‌ها",
            },
        },
    },
    {
        path: "/action/submit/activity/",
        elementKey: "SubmitActivity",
        meta: {
            title: "ثبت فعالیت",
            breadcrumb: ["عملیات", "ثبت فعالیت"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "operations",
                icon: "feather-plus-circle",
                label: "ثبت فعالیت",
            },
        },
    },
    {
        path: "/action/correction/activity/",
        elementKey: "CorrectActivity",
        meta: {
            title: "اصلاح فعالیت",
            breadcrumb: ["عملیات", "اصلاح فعالیت"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "operations",
                icon: "feather-edit-2",
                label: "اصلاح فعالیت",
            },
        },
    },
    {
        path: "/action/accounting/reference/",
        elementKey: "AccountingReference",
        meta: {
            title: "استناد حسابداری",
            breadcrumb: ["عملیات", "استناد حسابداری"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "operations",
                icon: "feather-link",
                label: "استناد حسابداری",
            },
        },
    },
    {
        path: "/reports/accounting/documents/",
        elementKey: "AccountingDocuments",
        meta: {
            title: "اسناد حسابداری",
            breadcrumb: ["گزارشات", "اسناد حسابداری"],
            headerActions: {
                showDateRange: true,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "reports",
                icon: "feather-file-text",
                label: "اسناد حسابداری",
            },
        },
    },
    {
        path: "/reports/balance/",
        elementKey: "BalanceReports",
        meta: {
            title: "ترازها",
            breadcrumb: ["گزارشات", "ترازها"],
            headerActions: {
                showDateRange: true,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "reports",
                icon: "feather-scale",
                label: "ترازها",
            },
        },
    },
    {
        path: "/reports/accounts/circulation/",
        elementKey: "AccountsCirculation",
        meta: {
            title: "گردش حساب‌ها",
            breadcrumb: ["گزارشات", "گردش حساب‌ها"],
            headerActions: {
                showDateRange: true,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "reports",
                icon: "feather-refresh-cw",
                label: "گردش حساب‌ها",
            },
        },
    },
    {
        path: "/reports/review/accounts/",
        elementKey: "ReviewAccounts",
        meta: {
            title: "مرور حساب‌ها",
            breadcrumb: ["گزارشات", "مرور حساب‌ها"],
            headerActions: {
                showDateRange: true,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "reports",
                icon: "feather-eye",
                label: "مرور حساب‌ها",
            },
        },
    },
    {
        path: "/invoice/type/",
        elementKey: "InvoiceTypes",
        meta: {
            title: "انواع صورتحساب",
            breadcrumb: ["صورتحساب", "انواع صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-type",
                label: "انواع صورتحساب",
            },
        },
    },
    {
        path: "/invoice/fields/",
        elementKey: "InvoiceFields",
        meta: {
            title: "کالاهای صورتحساب",
            breadcrumb: ["صورتحساب", "کالاهای صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-shopping-cart",
                label: "کالاهای صورتحساب",
            },
        },
    },
    {
        path: "/invoice/method/",
        elementKey: "InvoiceMethods",
        meta: {
            title: "روش‌های تسویه",
            breadcrumb: ["صورتحساب", "روش‌های تسویه"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-dollar-sign",
                label: "روش‌های تسویه",
            },
        },
    },
    {
        path: "/invoices/list/",
        elementKey: "Invoices",
        meta: {
            title: "لیست صورتحساب‌ها",
            breadcrumb: ["صورتحساب", "لیست صورتحساب‌ها"],
            headerActions: {
                showDateRange: true,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-list",
                label: "لیست صورتحساب‌ها",
            },
        },
    },
    {
        path: "/invoice/issuance/",
        elementKey: "InvoiceSender",
        meta: {
            title: "صدور صورتحساب",
            breadcrumb: ["صورتحساب", "صدور صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-plus",
                label: "صدور صورتحساب",
            },
        },
    },
    {
        path: "/invoice/view/:id/",
        elementKey: "InvoiceSender",
        meta: {
            title: "مشاهده صورتحساب",
            breadcrumb: ["صورتحساب", "لیست صورتحساب‌ها", "مشاهده صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-eye",
                label: "مشاهده صورتحساب",
            },
        },
    },
    {
        path: "/invoice/edit/:id/",
        elementKey: "InvoiceSender",
        meta: {
            title: "ویرایش صورتحساب",
            breadcrumb: ["صورتحساب", "لیست صورتحساب‌ها", "ویرایش صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-edit",
                label: "ویرایش صورتحساب",
            },
        },
    },
    {
        path: "/facilities/users/",
        elementKey: "FacilityUsers",
        meta: {
            title: "کاربران",
            breadcrumb: ["امکانات", "کاربران"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "facilities",
                icon: "feather-users",
                label: "کاربران",
            },
        },
    },
    {
        path: "/facilities/users/permission/",
        elementKey: "UserPermissions",
        meta: {
            title: "دسترسی کاربران",
            breadcrumb: ["امکانات", "دسترسی کاربران"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "facilities",
                icon: "feather-shield",
                label: "دسترسی کاربران",
            },
        },
    },
    {
        path: "/facilities/course/select/",
        elementKey: "CourseSelection",
        meta: {
            title: "انتخاب دوره",
            breadcrumb: ["امکانات", "انتخاب دوره"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "facilities",
                icon: "feather-calendar",
                label: "انتخاب دوره",
            },
        },
    },
    {
        path: "/facilities/settings/",
        elementKey: "Settings",
        meta: {
            title: "تنظیمات",
            breadcrumb: ["امکانات", "تنظیمات"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "facilities",
                icon: "feather-settings",
                label: "تنظیمات",
            },
        },
    },
    {
        path: "/products/units/",
        elementKey: "UnitMeasure",
        meta: {
            title: "واحد اندازه‌گیری",
            breadcrumb: ["کالاها و خدمات", "واحد اندازه‌گیری"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "products",
                icon: "feather-ruler",
                label: "واحد اندازه‌گیری",
            },
        },
    },
    {
        path: "/products/management/",
        elementKey: "UserProducts",
        meta: {
            title: "مدیریت کالاها و خدمات",
            breadcrumb: ["کالاها و خدمات", "مدیریت کالاها و خدمات"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "products",
                icon: "feather-package",
                label: "مدیریت کالاها و خدمات",
            },
        },
    },
    {
        path: "/location/country/",
        elementKey: "Country",
        meta: {
            title: "کشور",
            breadcrumb: ["مکان‌ها", "کشور"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "locations",
                icon: "feather-flag",
                label: "کشور",
            },
        },
    },
    {
        path: "/location/province/",
        elementKey: "Province",
        meta: {
            title: "استان",
            breadcrumb: ["مکان‌ها", "استان"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "locations",
                icon: "feather-map",
                label: "استان",
            },
        },
    },
    {
        path: "/location/city/",
        elementKey: "City",
        meta: {
            title: "شهر",
            breadcrumb: ["مکان‌ها", "شهر"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "locations",
                icon: "feather-navigation",
                label: "شهر",
            },
        },
    },
    /* TEMP-HIDDEN: صندوق پستی — restore when needed
    {
        path: "/notifications/",
        elementKey: "Notifications",
        meta: {
            title: "اعلان‌ها",
            breadcrumb: ["اعلان‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "notifications",
                icon: "feather-bell",
                label: "اعلان‌ها",
                showAlways: true
            },
        },
    },
    */
    {
        path: "/ticket/list/",
        elementKey: "TicketList",
        meta: {
            title: "لیست تیکت‌ها",
            breadcrumb: ["تیکت‌ها", "لیست تیکت‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "tickets",
                icon: "feather-list",
                label: "لیست تیکت‌ها",
            },
        },
    },
    {
        path: "/ticket/create/",
        elementKey: "TicketCreate",
        meta: {
            title: "تیکت جدید",
            breadcrumb: ["تیکت‌ها", "تیکت جدید"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "tickets",
                icon: "feather-plus",
                label: "تیکت جدید",
            },
        },
    },
    {
        path: "/ticket/chat/:id/",
        elementKey: "TicketChat",
        meta: {
            title: "چت تیکت",
            breadcrumb: ["تیکت‌ها", "لیست تیکت‌ها", "چت تیکت"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [
                    {
                        type: "link",
                        label: "بازگشت به لیست تیکت‌ها",
                        variant: "primary",
                        to: "/ticket/list/",
                    },
                ],
            },
            sidebar: {
                group: "tickets",
                icon: "feather-message-circle",
                label: "چت تیکت",
            },
        },
    },
    {
        path: "/terms-and-rules/rules/",
        elementKey: "Rule",
        meta: {
            title: "قوانین",
            breadcrumb: ["قوانین و شرایط", "قوانین"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "terms_rules",
                icon: "feather-file-text",
                label: "قوانین",
            },
        },
    },
    {
        path: "/subscription/general/",
        elementKey: "SubscriptionPlans",
        meta: {
            title: "پلن‌های اشتراک",
            breadcrumb: ["اشتراک‌ها", "پلن‌های اشتراک"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "subscriptions",
                icon: "feather-clipboard",
                label: "پلن‌های اشتراک",
            },
        },
    },
    {
        path: "/subscription/all/",
        elementKey: "SubscriptionHistory",
        meta: {
            title: "تاریخچه اشتراک",
            breadcrumb: ["اشتراک‌ها", "تاریخچه اشتراک"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "subscriptions",
                icon: "feather-history",
                label: "تاریخچه اشتراک",
            },
        },
    },
    {
        path: "/subscription/app/",
        elementKey: "SubscriptionHistory",
        meta: {
            title: "نرم افزار سامانه مودیان",
            breadcrumb: ["اشتراک‌ها", "نرم افزار سامانه مودیان"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "subscriptions",
                icon: "feather-cpu",
                label: "نرم افزار سامانه مودیان",
            },
        },
    },
    {
        path: "/profile/details/",
        elementKey: "ProfileDetails",
        meta: {
            title: "جزئیات حساب کاربری",
            breadcrumb: ["پروفایل", "جزئیات حساب کاربری"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "profile",
                icon: "feather-user",
                label: "جزئیات حساب کاربری",
                showAlways: true
            },
        },
    },
];


const routeConfig = [
    {
        path: "/dashboard/",
        elementKey: "Dashboard",
        meta: {
            title: "داشبورد",
            breadcrumb: ["داشبورد"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "dashboard",
                icon: "feather-home",
                label: "داشبورد اصلی",
            },
        },
    },

    {
        path: "/products/units/",
        elementKey: "UnitMeasure",
        meta: {
            title: "واحد اندازه گیری",
            breadcrumb: ["کالا ها و خدمات", "واحد اندازه گیری"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "products",
                icon: "feather-layers",
                label: "واحد اندازه گیری",
            },
        },
    },

    {
        path: "/products/management/",
        elementKey: "UserProducts",
        meta: {
            title: "کالا ها و خدمات",
            breadcrumb: ["کالا ها و خدمات", "مدیریت کالا ها و خدمات"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "products",
                icon: "feather-box",
                label: "کالاها و خدمات",
            },
        },
    },
    {
        path: "/profile/details/",
        elementKey: "ProfileCreate",
        meta: {
            title: "جزئیات حساب کاربری",
            breadcrumb: ["دکمه پروفایل", "جزئیات حساب کاربری"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "profile",
                icon: "feather-user-plus",
                label: "جزئیات حساب کاربری",
            },
        },
    },
    {
        path: "/profile/users/",
        elementKey: "ProfileUsers",
        meta: {
            title: "فهرست اشخاص",
            breadcrumb: ["اشخاص", "فهرست اشخاص"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            }
        },
    },

    /* TEMP-HIDDEN: صندوق پستی — restore when needed
    {
        path: "/notifications/",
        elementKey: "Notifications",
        meta: {
            title: "صندوق پستی",
            breadcrumb: ["اعلان ها", "صندوق پستی"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "notifications",
                icon: "feather-mail",
                label: "صندوق پستی",
            },
        },
    },
    */
    {
        path: "/invoice/fields/",
        elementKey: "InvoiceFields",
        meta: {
            title: "اقلام صورتحساب",
            breadcrumb: ["فاکتور ها", "اقلام صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "اقلام صورتحساب",
            },
        },
    },
    {
        path: "/invoice/issuance/",
        elementKey: "InvoiceSender",
        meta: {
            title: "صدور صورتحساب",
            breadcrumb: ["فاکتور ها", "صدور صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "صدور صورتحساب",
            },
        },
    },
    {
        path: "/invoices/list/",
        elementKey: "Invoices",
        meta: {
            title: "لیست صورتحساب",
            breadcrumb: ["فاکتور ها", "لیست صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "لیست صورتحساب",
            },
        },
    },
    {
        path: "/invoice/view/:id/",
        elementKey: "InvoiceSender",
        meta: {
            title: "مشاهده صورتحساب",
            breadcrumb: ["فاکتور ها", "لیست صورتحساب", "مشاهده صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "مشاهده صورتحساب",
            },
        },
    },
    {
        path: "/invoice/edit/:id/",
        elementKey: "InvoiceSender",
        meta: {
            title: "ویرایش صورتحساب",
            breadcrumb: ["فاکتور ها", "لیست صورتحساب", "ویرایش صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "ویرایش صورتحساب",
            },
        },
    },
    {
        path: "/invoice/method/",
        elementKey: "InvoiceMethods",
        meta: {
            title: "روش های تسویه",
            breadcrumb: ["فاکتور ها", "روش های تسویه"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "روش‌های تسویه",
            },
        },
    },
    {
        path: "/invoice/pattern/",
        elementKey: "InvoicePatterns",
        meta: {
            title: "الگو های صورتحساب",
            breadcrumb: ["فاکتور ها", "الگو های صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "الگو های صورتحساب",
            },
        },
    },
    {
        path: "/invoice/type/",
        elementKey: "InvoiceTypes",
        meta: {
            title: "انواع صورتحساب",
            breadcrumb: ["فاکتور ها", "انواع صورتحساب"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "invoice",
                icon: "feather-credit-card",
                label: "انواع صورتحساب",
            },
        },
    },
    {
        path: "/location/country/",
        elementKey: "Country",
        meta: {
            title: "کشور",
            breadcrumb: ["کشور، استان و شهر", "کشور"],
            filters: [],
            buttons: [],
            showDateRange: false,
            sidebar: {
                group: "location",
                icon: "feather-map-pin",
                label: "کشور، استان و شهر",
            },
        },
    },
    {
        path: "/location/province/",
        elementKey: "Province",
        meta: {
            title: "استان",
            breadcrumb: ["کشور، استان و شهر", "استان"],
            filters: [],
            buttons: [],
            showDateRange: false,
            sidebar: {
                group: "location",
                icon: "feather-map-pin",
                label: "کشور، استان و شهر",
            },
        },
    },
    {
        path: "/location/city/",
        elementKey: "City",
        meta: {
            title: "شهر",
            breadcrumb: ["کشور، استان و شهر", "شهر"],
            filters: [],
            buttons: [],
            showDateRange: false,
            sidebar: {
                group: "location",
                icon: "feather-map-pin",
                label: "کشور، استان و شهر",
            },
        },
    },
    {
        path: "/ticket/list/",
        elementKey: "TicketList",
        meta: {
            title: "لیست تیکت‌ها",
            breadcrumb: ["تیکت ها", "تیکت‌ها"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "ticket",
                icon: "feather-life-buoy",
                label: "تیکت‌ها",
            },
        },
    },
    {
        path: "/ticket/create/",
        elementKey: "TicketCreate",
        meta: {
            title: "ساخت تیکت جدید",
            breadcrumb: ["تیکت ها", "ساخت تیکت جدید"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "ticket",
                icon: "feather-life-buoy",
                label: "تیکت جدید",
            },
        },
    },
    {
        path: "/ticket/chat/:id/",
        elementKey: "TicketChat",
        meta: {
            title: "تیکت",
            breadcrumb: ["تیکت ها", "لیست تیکت ها", "تیکت"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [
                    {
                        type: "link",
                        label: "بازگشت به لیست تیکت ها",
                        variant: "primary",
                        to: "/ticket/list/",
                    },
                ],
            },
            sidebar: {
                group: "ticket",
                icon: "feather-message-circle",
                label: "چت تیکت",
            },
        },
    },
    {
        path: "/terms-and-rules/rules/",
        elementKey: "Rule",
        meta: {
            title: "قوانین",
            breadcrumb: ["قوانین و شرایط", "قوانین"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "terms_and_services",
                icon: "feather-file-text",
                label: "قوانین",
            },
        },
    },
    {
        path: "/subscription/general/",
        elementKey: "SubscriptionPlans",
        meta: {
            title: "پلن های اشتراک",
            breadcrumb: ["اشتراک ها", "عمومی"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "subscription",
                icon: "feather-clipboard",
                label: "عمومی",
            },
        },
    },
    {
        path: "/subscription/all/",
        elementKey: "SubscriptionHistory",
        meta: {
            title: "تاریخچه اشتراک",
            breadcrumb: ["اشتراک ها", "همه"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "subscription",
                icon: "feather-clipboard",
                label: "همه",
            },
        },
    },
    {
        path: "/subscription/app/",
        elementKey: "SubscriptionHistory",
        meta: {
            title: "نرم افزار سامانه مودیان",
            breadcrumb: ["اشتراک ها", "نرم افزار سامانه مودیان"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "subscription",
                icon: "feather-clipboard",
                label: "نرم افزار سامانه مودیان",
            },
        },
    },
    /* TEMP-HIDDEN: صدور فرم خرید صورتحساب — restore when needed
    {
        path: "/purchase/form/",
        elementKey: "PurchaseForm",
        meta: {
            title: "فرم خرید",
            breadcrumb: ["اعلان‌ها", "فرم خرید"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "notifications",
                icon: "feather-bell",
                label: "فرم خرید",
                showAlways: true
            },
        },
    },
    */
    {
        path: "/sale/form/",
        elementKey: "SaleForm",
        meta: {
            title: "فرم فروش",
            breadcrumb: ["اعلان‌ها", "فرم فروش"],
            headerActions: {
                showDateRange: false,
                filters: [],
                buttons: [],
            },
            sidebar: {
                group: "notifications",
                icon: "feather-bell",
                label: "فرم فروش",
                showAlways: true
            },
        },
    },

];

export default routeConfig;